export const PROSPECTING_WORKSPACE_ACCESS = 'prospecting-workspace-access';
export const REVENUE_ANALYTICS = 'revenue-analytics';
export const HD_SERVICE_ANALYTICS_SCOPE = 'hd-service-analytics';
export const REPORTS_SALES_PRO_ACCESS = 'reports-sales-pro-access';